import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { JOIN_SITE } from "../../@global/queries";
import logger from "../../@global/logger";

// Page queries must not start until authentication and site membership are ready.
export default function useSiteAccess(keycloak, initialized, bearer_token, site_id) {
  const [joinSite] = useMutation(JOIN_SITE);
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState({});
  const authenticated = Boolean(keycloak.authenticated);
  const auth_ready = initialized && (!authenticated || Boolean(bearer_token));
  const session = JSON.stringify([site_id, authenticated, keycloak.subject, attempt]);

  useEffect(() => {
    if (!auth_ready) return;
    let cancelled = false;

    if (!authenticated) {
      setResult({ session, ready: true });
    } else {
      joinSite({ variables: { site_id } }).then(
        () => {
          if (!cancelled) setResult({ session, ready: true });
        },
        (error) => {
          if (!cancelled) setResult({ session, error });
          logger.error(error);
        }
      );
    }

    return () => { cancelled = true; };
  }, [auth_ready, authenticated, session, site_id, joinSite]);

  return {
    ready: auth_ready && result.session === session && Boolean(result.ready),
    error: auth_ready && result.session === session ? result.error : undefined,
    retry: () => setAttempt((value) => value + 1),
  };
}
